import React from 'react'
import Header from '../components/Shared/Header'
import CartMain from '../components/Product/CartMain'
import Footer from '../components/Shared/Footer'

function Cart() {
  return (
<>
    <div>
        <Header />
        <CartMain />
        <Footer />
    </div>
</>
  )
}

export default Cart
